import {Component, Fragment} from 'react';

import {TypeFlightPlanning} from 'topmeteo/general/constants';

import Marker from './Marker';
import Numbers from './Numbers';
import DragHandle from './DragHandle';
import PreloadBar from './PreloadBar';

class Slider extends Component {

    constructor(props) {
        super(props);

        this.startRef = this.ref.bind(this, 'start');
        this.stopRef = this.ref.bind(this, 'stop');
        this.routeStartHourRef = this.ref.bind(this, 'routeStartHour');
        this.routeArrivalTimeRef = this.ref.bind(this, 'routeArrivalTime');

        this.state = {
            start: null,
            stop: null,
            routeStartHour: null,
            routeArrivalTime: null,
        };
    }

    render() {
        const {type} = this.props;
        const showRoute = type === TypeFlightPlanning;
        const {start, stop, routeStartHour, routeArrivalTime} = this.state;

        return (
            <div className="component-slider-wrapper">
                <div className="component-slider">
                    <DragHandle.Start marker={start} />
                    <DragHandle.Stop marker={stop} />
                    {showRoute && (
                        <Fragment>
                            <DragHandle.RouteStartHour marker={routeStartHour} />
                            <DragHandle.RouteArrivalTime marker={routeArrivalTime} />
                        </Fragment>
                    )}
                    <div className="scale">
                        <Numbers />
                        <div className="slide">
                            <PreloadBar {...this.props} />
                            <Marker.Start node={start} nodeRef={this.startRef} />
                            <Marker.Stop node={stop} nodeRef={this.stopRef} />
                            {showRoute && (
                                <Fragment>
                                    <Marker.RouteStartHour
                                        node={routeStartHour}
                                        nodeRef={this.routeStartHourRef}
                                    />
                                    <Marker.RouteArrivalTime
                                        node={routeArrivalTime}
                                        nodeRef={this.routeArrivalTimeRef}
                                    />
                                </Fragment>
                            )}
                            <DragHandle.Now />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    ref(id, node) {
        this.setState({[id]: node || null});
    }

}

export default Slider;
